import produce, { Draft } from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { SmsTemplateState, initialSmsTemplateState } from './model';

const smsTemplate = produce((draft: Draft<SmsTemplateState>, action: ActionType<typeof actions>) => {
  switch (action.type) {
    case getType(actions.getSmsTemplateList.request): {
      draft.list.loading = true;
      return draft;
    }
    case getType(actions.getSmsTemplateList.success): {
      draft.list.loading = true;
      draft.list.response = action.payload;
      return draft;
    }
    case getType(actions.getSmsTemplateList.failure): {
      draft.list.loading = false;
      draft.list.errors = action.payload;
      return draft;
    }
    case getType(actions.getSmsTemplateDetails.request): {
      draft.details.loading = true;
      draft.details.response = undefined;
      draft.details.errors = undefined;
      return draft;
    }
    case getType(actions.getSmsTemplateDetails.success): {
      draft.details.loading = true;
      draft.details.response = action.payload;
      return draft;
    }
    case getType(actions.getSmsTemplateDetails.failure): {
      draft.details.loading = false;
      draft.details.errors = action.payload;
      return draft;
    }
    case getType(actions.createSmsTemplate.request): {
      draft.create.loading = true;
      return draft;
    }
    case getType(actions.createSmsTemplate.success): {
      draft.create.loading = false;
      draft.create.response = action.payload;
      return draft;
    }
    case getType(actions.createSmsTemplate.failure): {
      draft.create.loading = false;
      draft.create.errors = action.payload;
      return draft;
    }
    case getType(actions.updateSmsTemplate.request): {
      draft.update.loading = true;
      return draft;
    }
    case getType(actions.updateSmsTemplate.success): {
      draft.update.loading = false;
      draft.update.response = action.payload;
      return draft;
    }
    case getType(actions.updateSmsTemplate.failure): {
      draft.update.loading = false;
      draft.update.errors = action.payload;
      return draft;
    }
    case getType(actions.deleteSmsTemplate.request): {
      draft.delete.loading = true;
      return draft;
    }
    case getType(actions.deleteSmsTemplate.success): {
      draft.delete.loading = false;
      draft.delete.response = action.payload;
      return draft;
    }
    case getType(actions.deleteSmsTemplate.failure): {
      draft.delete.loading = false;
      draft.delete.errors = action.payload;
      return draft;
    }
    case getType(actions.bulkSmsTemplates.request): {
      draft.bulk.loading = true;
      return draft;
    }
    case getType(actions.bulkSmsTemplates.success): {
      draft.bulk.loading = false;
      draft.bulk.response = action.payload;
      return draft;
    }
    case getType(actions.bulkSmsTemplates.failure): {
      draft.bulk.loading = false;
      draft.bulk.errors = action.payload;
      return draft;
    }
    case getType(actions.clearData): {
      if (action.payload) {
        draft[action.payload] = {};
      } else {
        draft = initialSmsTemplateState;
      }
      return draft;
    }
    default: {
      return draft;
    }
  }
}, initialSmsTemplateState);

export default smsTemplate;
